import { debounce } from 'debounce';
import { h, Component } from 'preact';
import { getScaleToFitStyles } from 'utilities/rendering';
import { fullscreen } from 'utilities/context';
import { PLAYER_EVENT, ANNOTATION_EVENT } from 'constants/events';
import { FREQUENT_EVENT_THROTTLE_MS } from 'configuration/defaults';

export class PresentationScaleManager extends Component {
    constructor(props) {
        super(props);

        this.state = {
            ...this.windowDimensions,
            inFullscreen: false
        };

        fullscreen.onChange(this.onFullscreenChange);
        props.bus.on(PLAYER_EVENT.FULLSCREEN_CHANGE_REQUESTED, this.onFullscreenChangeRequest);
        props.bus.on(ANNOTATION_EVENT.ENTER_FULLSCREEN, this.onEnterFullscreen);
        props.bus.on(ANNOTATION_EVENT.EXIT_FULLSCREEN, this.onExitFullscreen);
        window.addEventListener('resize', debounce(this.onWindowResize, FREQUENT_EVENT_THROTTLE_MS));
    }

    onEnterFullscreen = () => {
        fullscreen.enter(this.fsContainer)
    }

    onExitFullscreen = () => {
        if (!this.state.inFullscreen) {
            return; 
        }

        fullscreen.exit(this.fsContainer)
    }

    onFullscreenChangeRequest = event => {
        if (this.fsContainer) {
            if (!this.state.inFullscreen) {
                fullscreen.enter(this.fsContainer);
            } else {
                fullscreen.exit(this.fsContainer);
            }
        }
    }

    onWindowResize = event => {
        this.setState(this.windowDimensions);
    }

    onFullscreenChange = event => {
        const { inFullscreen, supportsAPI } = fullscreen;

        this.setState({ inFullscreen });
        this.props.bus.emit(PLAYER_EVENT.FULLSCREEN_CHANGE, { inFullscreen, supportsAPI });
    };

    render() {
        const scaleStyles = this.shouldComputeScale ? getScaleToFitStyles(this.state.width, this.state.height, this.props.aspectRatio) : {};

        return (
            <div data-ref="fullscreen-container" ref={ ref => this.fsContainer = ref }>
                <div data-ref="scale-container" ref={ ref => this.scaleContainer = ref } style={ scaleStyles }>
                    { this.props.children }
                </div>
            </div>
        );
    }

    get shouldComputeScale() {
        return this.state.inFullscreen || this.props.alwaysScale;
    }

    get windowDimensions() {
        return {
            width: window.innerWidth,
            height: window.innerHeight
        };
    }
}